import * as React from 'react';
import Collapse from 'antd/lib/collapse';
import Flex from 'antd/lib/flex';
import Text from 'antd/lib/typography/Text';
import { antGrey } from '../styles/globalStyles';
import { CaretRightOutlined } from '@ant-design/icons';

interface StepRunPanelSectionProps {
    icon: React.ReactNode;
    title: string;
    titleExtra?: React.ReactNode;
    children: React.ReactNode;
}

export const StepRunPanelSection: React.FC<StepRunPanelSectionProps> = ({ icon, title, titleExtra, children }) => {
    return (
        <Collapse
            collapsible="header"
            bordered={false}
            defaultActiveKey={[]}
            className="step-run-panel-section"
            style={{
                backgroundColor: antGrey.grey2,
                borderRadius: '8px',
                border: `1px solid ${antGrey.grey5}`,
            }}
            expandIcon={({ isActive }) => (
                <CaretRightOutlined
                    style={{
                        color: antGrey.grey6,
                        fontSize: 18,
                    }}
                    rotate={isActive ? 90 : 0}
                />
            )}
            items={[
                {
                    key: '1',
                    label: (
                        <Flex align="center" gap={8}>
                            {icon}
                            <Text strong style={{ fontSize: 14, color: antGrey.grey7 }}>
                                {title}
                            </Text>
                            {titleExtra}
                        </Flex>
                    ),
                    children: (
                        <div
                            style={{
                                overflow: 'hidden',
                                borderRadius: 8,
                                border: `1px solid ${antGrey.grey5}`,
                            }}
                        >
                            {children}
                        </div>
                    ),
                    showArrow: true,
                    style: {
                        borderBottom: 'none',
                    },
                },
            ]}
        />
    );
};
